import { BASE_URL, SUBSCRIPTION,  } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ISubscription, ISubscriptionInput } from "models/subscription";

export async function getSubscription(data:any) : Promise<ISubscription[]> {
  const response = await axios.post(BASE_URL + SUBSCRIPTION +'/GetSubscriptions' ,data);
  return response.data;
}
export async function getSubscriptionStatus(params: string = "/statuses") : Promise<string[]> {
  const response = await axios.get(BASE_URL + SUBSCRIPTION + params);
  return response.data;
}

export async function paySubscription(id:number,planId:string) {
  const response = await axios.put(BASE_URL + SUBSCRIPTION + `/pay/${id}${!!planId ? `?advancePaymentId=${planId}`:""}`);
  return response.data;
}

export async function addSubscription(data: ISubscriptionInput) {
  const response = await axios.post(BASE_URL + SUBSCRIPTION, data);
  return response.data;
}

export async function editSubscription(data: ISubscriptionInput, id: string) {
  const response = await axios.patch(BASE_URL + SUBSCRIPTION + "/" + id , data);
  return response.data;
}

export async function deleteSubscription(id: string) {
  const response = await axios.delete(BASE_URL + SUBSCRIPTION + "/" + id);
  return response.data;
}

export async function SendReminder() {
  const response = await axios.post(BASE_URL + SUBSCRIPTION + '/sendReminder');
  return response.data;
}

export async function SendSupportMsg() {
  const response = await axios.post(BASE_URL + SUBSCRIPTION + '/SendSupportMsg');
  return response.data;
}

export const SubscriptionCells: HeadCell[] = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Client",
  },
  {
    id: "serviceName",
    numeric: false,
    disablePadding: false,
    label: "Service",
  },
  {
    id: "planName",
    numeric: false,
    disablePadding: false,
    label: "Plan",
  },
  {
    id: "resellerName",
    numeric: false,
    disablePadding: false,
    label: "Reseller",
  },
  {
    id: "startDate",
    numeric: false,
    disablePadding: false,
    label: "Start Date",
  },
  {
    id: "renewalDate",
    numeric: false,
    disablePadding: false,
    label: "Renewal Date",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];
